import { Outlet, useLocation, NavLink } from "react-router-dom";
import WrippleHelmet from "../../components/WrippleHelmet";
import React from "react";
import PageNotFound from "../../components/errors/PageNotFound";

const FinancialsLayout = () => {
    const location = useLocation();

    const navItems = [
        { path: "talent-payments", label: "Talent Time & Payments" },
        { path: "contract-progression", label: "Contract/CO Progression" },
        // Hidden for now. The view, its endpoint and the position export are
        // all still in place - uncomment this and the matching route in
        // config/navigation.js to bring the tab back.
        // { path: "project-burn-spend", label: "Project Burn & Spend" }
    ];

    if (TB.isProdEnv()) {
        return <PageNotFound />;
    }
    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
            <WrippleHelmet title="Financials Dashboard" />

            <div className="max-w-[95vw] mx-auto px-4 sm:px-6 lg:px-8 py-8">
                {/* Header Section */}
                <div className="mb-8">
                    <h1 className="text-4xl font-bold text-gray-900 mb-2">
                        Financials Dashboard
                    </h1>
                    <p className="text-gray-600 text-lg">
                        Track payments, contracts, and project financials in one place
                    </p>
                </div>

                {/* Navigation Tabs */}
                <nav className="mb-8">
                    <div className="border-b border-gray-200">
                        <div className="flex space-x-8 overflow-x-auto">
                            {navItems.map(item => (
                                <NavLink
                                    key={item.path}
                                    to={item.path}
                                    className={({ isActive }) =>
                                        `whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors duration-200 ${
                                            isActive
                                                ? 'border-indigo-600 text-indigo-600'
                                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                        }`
                                    }
                                >
                                    {item.label}
                                </NavLink>
                            ))}
                        </div>
                    </div>
                </nav>

                {/* Content Area */}
                <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                    <Outlet />
                </div>
            </div>
        </div>
    );
};

export default FinancialsLayout;